import React from 'react';
import ReactDOM from 'react-dom';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const MessageBox = ({ message, onClose, onConfirm, showConfirm = false, type = 'info' }) => {
    const { t } = useTranslation();
    const modalRoot = document.getElementById('modal-root');

    if (!modalRoot) return null;

    let iconComponent;
    let iconColorClass;
    switch (type) {
        case 'success':
            iconComponent = <LucideIcons.CheckCircle size={48} />;
            iconColorClass = 'text-green-400';
            break;
        case 'error':
            iconComponent = <LucideIcons.XCircle size={48} />;
            iconColorClass = 'text-red-400';
            break;
        case 'warning':
            iconComponent = <LucideIcons.AlertTriangle size={48} />;
            iconColorClass = 'text-yellow-400';
            break;
        case 'info':
        default:
            iconComponent = <LucideIcons.Info size={48} />;
            iconColorClass = 'text-blue-400';
            break;
    }

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center backdrop-blur-md" style={{ zIndex: 'var(--z-index-modal-top)' }}>
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-xl shadow-2xl max-w-sm w-full text-center border border-gray-700 animate-fade-in-up">
                <div className={`mx-auto mb-4 ${iconColorClass}`}>
                    {iconComponent}
                </div>
                <p className="text-lg font-semibold mb-6 text-blue-200 animate-text-fade-in">{message}</p>
                <div className="flex justify-center space-x-4">
                    <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300">{showConfirm ? t('messageBox.cancel') : t('messageBox.ok')}</button>
                    {showConfirm && (<button onClick={onConfirm} className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition duration-300">{t('messageBox.confirm')}</button>)}
                </div>
            </div>
        </div>,
        modalRoot
    );
};

export default MessageBox;
